import { useMemo } from "react";

import {
  LOCALE_OPTIONS,
  LOCALE_OPTIONS_PRECISE,
  OCC_CLEARING_FEE,
  OCC_CONTRACT_CAP,
  OPTIONS_CAT_FEE_PER_EES,
  OPTIONS_MULTIPLIER,
  OPTIONS_REGULATORY_FEE,
  OPTIONS_TAF_FEE,
} from "~/v2/constants/optionOrder";

export interface FeesResult {
  occClearingFee: string;
  optionsRegulatoryFee: string;
  tafFee: string;
  catFee: string;
}

export const getFees = (quantity: number, isSell: boolean): FeesResult => {
  const taf = isSell ? OPTIONS_TAF_FEE * quantity : 0;
  const cat = OPTIONS_CAT_FEE_PER_EES * quantity * OPTIONS_MULTIPLIER;

  return {
    occClearingFee: (
      OCC_CLEARING_FEE * Math.min(quantity, OCC_CONTRACT_CAP)
    ).toLocaleString("en-US", LOCALE_OPTIONS),
    optionsRegulatoryFee: (OPTIONS_REGULATORY_FEE * quantity).toLocaleString(
      "en-US",
      LOCALE_OPTIONS,
    ),
    tafFee: taf.toLocaleString("en-US", LOCALE_OPTIONS),
    catFee: cat.toLocaleString("en-US", LOCALE_OPTIONS_PRECISE),
  };
};

interface UseFeesProps {
  quantity: number;
  isSell: boolean;
}

export const useFees = ({ quantity, isSell }: UseFeesProps) =>
  useMemo(() => getFees(quantity, isSell), [quantity, isSell]);
